import React from "react";
import { UI } from "@wwimmo/ui";
import { format } from "date-fns";
import styles from "./AssemblyListRow.module.css";
import { Assembly } from "src/stores/assemblies/AssemblyStore";

export const AssemblyListRowMobile = (props: { assembly: Assembly }) => {
    const { id, date, assemblyrealestates, street, housenumber, zip, city } = props.assembly;

    if (assemblyrealestates.length === 0) {
        return <div>/</div>;
    }

    return (
        <UI.List.Row className={styles.TicketListRowMobile} key={`row-mobile-${id}`}>
            <div className={styles.MobileTop}>
                <div className={styles.RealestateNames}>
                    <strong>
                        {assemblyrealestates[0].realestate.name}
                        {assemblyrealestates.length > 1 && (
                            <>
                                , <span className={styles.Dots}>...</span>
                            </>
                        )}
                    </strong>
                </div>
            </div>
            <div className={styles.MobileBottom}>
                <div className={styles.MobileLeft}>
                    <div>
                        <div>
                            {street} {housenumber}
                        </div>
                        <div>
                            {zip} {city}
                        </div>
                    </div>
                </div>
                <div className={styles.MobileRight}>{date && format(new Date(date), "dd.MM.yy")}</div>
            </div>
        </UI.List.Row>
    );
};
